import { memo } from 'react';
import { useTranslation } from 'react-i18next';

import { useCallbackRef } from '@/js/libs/hooks/useCallbackRef';
import { useNavigate } from '@/js/libs/router';
import { Button, DropdownList, Icons } from '@/js/libs/ui/src/V2';
import { PrivateContent, Roles, or, not } from '@/js/libs/use-auth';

import { ROUTER } from 'src/AppRouter';
import useAppLogout from 'src/hooks/useAppLogout';

export const AccountButton = memo(function AccountButton() {
  const [t] = useTranslation(['common', 'components']);
  const navigate = useNavigate();
  const logout = useAppLogout();

  const handleNavigateToSettings = useCallbackRef(() => {
    navigate(ROUTER['/account/edit-settings'].path.pattern);
  });

  const handleNavigateToCompany = useCallbackRef(() => {
    navigate(ROUTER['/account/company'].path.pattern);
  });

  return (
    <DropdownList
      minWidth={false}
      buttonComponent={
        <Button iconOnly ghost data-testid='account-button' title={t('common:PROFILE')}>
          <Icons.Person size={20} />
        </Button>
      }>
      <PrivateContent roles={not(Roles.SSO)}>
        <DropdownList.DropdownItem icon={<Icons.Person />} onClick={handleNavigateToSettings} dataTestId='manage-account-button'>
          {t('components:MANAGE_ACCOUNT')}
        </DropdownList.DropdownItem>
      </PrivateContent>

      <PrivateContent roles={or(Roles.ADMIN, Roles.COMPANY_ADMIN)}>
        <DropdownList.DropdownItem icon={<Icons.Company />} onClick={handleNavigateToCompany} dataTestId='manage-company-button'>
          {t('components:COMPANY_EDIT')}
        </DropdownList.DropdownItem>
      </PrivateContent>

      <DropdownList.DropdownItem icon={<Icons.Logout />} onClick={logout} dataTestId='user-logout-button'>
        {t('components:LOGOUT')}
      </DropdownList.DropdownItem>
    </DropdownList>
  );
});
